







































































import Component from "vue-class-component";
import Vue from "vue";
import {Prop, Watch} from "vue-property-decorator";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {Author, AuthorDTO} from "../model/interface/author";
import {WhitelistService} from "../services/whitelist.service";
import AuthorAddComponent from "./author-add.vue";
import AuthorAddMultiComponent from "./author-multi-add.vue";

@Component({
  components: {
    AuthorAddComponent,
    AuthorAddMultiComponent
  }
})
export default class ProjectWhitelistComponent extends Vue {
  @Prop(Number) projectId!: number;
  @Prop(String) projectAlias!: string;
  @Prop(Number) activateDialog!: number;

  private loading: boolean = false;
  private whitelist: Author[] = [];
  private showAuthorAddDialog: number = 0;
  private showAuthorMultiAddDialog: number = 0;
  private showDialog: boolean = false;
  private selectedAuthor: Author = null;
  private openDropWhitelistDialog: boolean = false;

  async mounted() {
    this.showDialog = true;
    //API request to get Whitelist
    try {
      const whitelist: Author[] | false = await WhitelistService.getWhitelist(this.projectId);
      if(!whitelist) {
        MessageBus.$emit(AlertType[AlertType.error], 'Error during Whitelist fetch!');
        return;
      }
      this.whitelist = whitelist;
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Project update! ' + e);
    } finally {
      this.loading = false;
    }
  }

  @Watch("activateDialog")
  onDialogChange(activateDialog: number) {
    this.showDialog = true;
  }

  private onSelectAuthor(author: Author) {
    this.selectedAuthor = author;
  }
  private openDropWhitelistDialogAction() {
    this.openDropWhitelistDialog = true;
  }

  get noAuthorPresent() {
    return this.whitelist.length === 0;
  }
  get noAuthorSelected() {
    return !this.selectedAuthor;
  }
  get exportWhitelistButtonDisabled() {
    return {
      'wimpub_button_disabled': this.noAuthorPresent
    };
  }
  private async removeAuthor() {
    try {
      let whitelist = <number | false> await WhitelistService.removeAuthorFromWhitelist(this.projectId, this.selectedAuthor);
      this.whitelist.splice(this.whitelist.indexOf(this.selectedAuthor),1);
      MessageBus.$emit(AlertType[AlertType.success], `Author ${this.selectedAuthor.firstName} ${this.selectedAuthor.lastName} removed from Whitelist!`);
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], e);
    } finally {
      this.selectedAuthor = null;
    }
  }

  private showAuthorAddDialogAction() {
    this.showAuthorAddDialog++;
  }
  private showAuthorMultiAddDialogAction() {
    this.showAuthorMultiAddDialog++;
  }
  private downloadWhitelist() {
    const data: string = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.generatedJSONWhitelist(this.whitelist)));

    const a: HTMLAnchorElement = document.createElement('a');
    a.setAttribute("href", 'data:' + data);
    a.setAttribute("download", `${this.projectId}_${this.projectAlias}_whitelist.json`);
    a.setAttribute("style", "none");
    a.click();
  }
  private generatedJSONWhitelist(whitelist: Author[]): AuthorDTO[] {
    let authorDTO: AuthorDTO[] = []
    whitelist.forEach((author: Author) => {
      authorDTO.push(Author.toJSON(author));
    });
    return authorDTO;
  }
  private async dropWhitelist() {
    try {
      let whitelist = <number | false> await WhitelistService.dropWhitelist(this.projectId);
      if(whitelist && whitelist === this.projectId) {
        this.whitelist.splice(0, this.whitelist.length)
        MessageBus.$emit(AlertType[AlertType.success], `Whitelist successfully removed!`);
      }
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], e);
    } finally {
      this.selectedAuthor = null;
    }
  }

}
